<template>
    <modal v-bind="$attrs" v-on="$listeners">
      <template v-slot:title>
        <h1>
            {{ $t('organization_profile.change_pass_dummy_modal.change_pass_dummy_title') }}
        </h1>
      </template>
      <template v-slot:body>
        <el-form class="auth-form" :model="form" :rules="rules" ref="form" >
          <div class="form-row">
            <elsa-input name="new_password" :label="$t('organization_profile.change_pass_dummy_modal.new_password')" class="new-password" v-model.lazy="form.new_password">
              {{ $t('organization_profile.change_pass_dummy_modal.new_password') }}
            </elsa-input>
            <elsa-input name="confirm_password" :label="$t('organization_profile.change_pass_dummy_modal.confirm_password')" class="confirm-password"  v-model.lazy="form.confirm_password">
              {{ $t('organization_profile.change_pass_dummy_modal.confirm_password') }}
            </elsa-input>
          </div>
        </el-form>
      </template>
      <template v-slot:footer>
        <span class="dialog-footer elsa-button-footer">
            <tertiary-button @click.native="handleCancelClick">
                {{ $t('common.cancel') }}
            </tertiary-button>
            <primary-button type="submit" ref="submit" disabled @click.native="handleChangePassDummy">
                {{ $t('common.confirm') }}
            </primary-button>
        </span>
      </template>
    </modal>
  </template>
  
  <script>
  import Modal from '@/components/common/Modal'
  import ElsaInput from '@/components/common/Input'
  import { handleFormValidation, handleSubmitButtonState } from '@/helpers/formValidationHelper'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton.vue'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton.vue'

  export default {
    components: {
      Modal,
      ElsaInput,
      TertiaryButton,
      PrimaryButton,
    },
    props: {
    },
    data() {
      return {
        errors: {},
        form: {
            new_password: '',
            confirm_password: '',
        },
        rules: {
            new_password: [
                { required: true, message: this.$t('organization_profile.change_pass_dummy_modal.new_password_required'), trigger: 'blur' },
                { min: 8, message: this.$t('organization_profile.change_pass_dummy_modal.new_password_min'), trigger: 'blur' },
            ],
            confirm_password: [
                { required: true, message: this.$t('organization_profile.change_pass_dummy_modal.confirm_password_required'), trigger: 'blur' },
                { min: 8, message: this.$t('organization_profile.change_pass_dummy_modal.confirm_password_min'), trigger: 'blur' },
            ],
        },
      }
    },
    methods: {
      handleCancelClick() {
        this.resetModal()
      },
      handleChangePassDummy() {
        return handleFormValidation(this.$refs.form, this.changePassDummy, this.handleError)
      },
      changePassDummy() {
        this.$emit('change-pass-dummy', this.form)
        this.resetModal()
      },
      handleError(error) {
        this.errors = error
      },
      onFormChange() {
        if (this.$refs.submit) {
            handleSubmitButtonState(this.$refs.submit.$el, (this.form.new_password && this.form.new_password == this.form.confirm_password))
        }
      },
      resetModal() {
        this.errors = {}
        this.$refs.form.resetFields()
        if(this.$refs.submit) {
            handleSubmitButtonState(this.$refs.submit.$el, false)
        }
        this.$emit('closed')
      }
    },
    watch: {
      form: {
        handler: 'onFormChange',
        deep: true
      }
    },
  }
  </script>
  
<style lang="scss" scoped>
  ::v-deep .el-form .el-form-item .el-form-item__label {
    text-transform: capitalize;
  }
  .auth-form {
    .form-row {
      display: flex;
      .confirm-password,
      .new-password {
        width: 50%;
      }
      .new-password {
        margin-right: 30px;
      }
    }
  }
</style>
 
  
  